export const toeflWords = [
  {
    word: "accurate",
    image: "https://images.unsplash.com/photo-1581091012184-0f3b05caa399",
    synonyms: ["precise", "correct", "exact"],
    example: "The data must be accurate to ensure valid results.",
    definition: "Free from errors; exact and correct."
  },
  {
    word: "analyze",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
    synonyms: ["examine", "evaluate", "assess"],
    example: "The scientist analyzed the chemical reaction.",
    definition: "To study something in detail to understand it."
  },
  {
    word: "benefit",
    image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e",
    synonyms: ["advantage", "gain", "profit"],
    example: "One benefit of exercise is improved health.",
    definition: "Something that is helpful or useful."
  },
  {
    word: "complex",
    image: "https://images.unsplash.com/photo-1610440447046-1ec1e0b69995",
    synonyms: ["complicated", "intricate", "elaborate"],
    example: "This is a complex mathematical problem.",
    definition: "Made of many parts; not simple."
  },
  {
    word: "considerable",
    image: "https://images.unsplash.com/photo-1589830702597-1c996f48f3c4",
    synonyms: ["significant", "substantial", "large"],
    example: "The company invested a considerable amount of money.",
    definition: "Fairly large or important."
  },
  {
    word: "contribute",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    synonyms: ["add", "give", "donate"],
    example: "Each team member contributed ideas to the project.",
    definition: "To give or add something."
  },
  {
    word: "decline",
    image: "https://images.unsplash.com/photo-1614642264761-69012d9d3ff6",
    synonyms: ["decrease", "diminish", "reduce"],
    example: "There has been a decline in profits this year.",
    definition: "To become less or worse."
  },
  {
    word: "emphasize",
    image: "https://images.unsplash.com/photo-1615719413546-0a3abfe3521c",
    synonyms: ["highlight", "stress", "underline"],
    example: "He emphasized the importance of teamwork.",
    definition: "To give special attention to something."
  },
  {
    word: "evaluate",
    image: "https://images.unsplash.com/photo-1515586171461-04e207b927f7",
    synonyms: ["assess", "judge", "estimate"],
    example: "We need to evaluate the results carefully.",
    definition: "To judge the value or condition of something."
  },
  {
    word: "expand",
    image: "https://images.unsplash.com/photo-1549921296-3a6b450e979e",
    synonyms: ["grow", "enlarge", "increase"],
    example: "The company plans to expand into Asia.",
    definition: "To increase in size or number."
  },
  {
    word: "indicate",
    image: "https://images.unsplash.com/photo-1614206554084-5c85edec4e2b",
    synonyms: ["show", "demonstrate", "point out"],
    example: "The results indicate a need for improvement.",
    definition: "To show or suggest something."
  },
  {
    word: "interpret",
    image: "https://images.unsplash.com/photo-1607623814075-fb6ebcf50fb4",
    synonyms: ["explain", "translate", "clarify"],
    example: "How should we interpret this data?",
    definition: "To explain the meaning of something."
  },
  {
    word: "justify",
    image: "https://images.unsplash.com/photo-1584697964154-993fdde9ba74",
    synonyms: ["defend", "explain", "support"],
    example: "Can you justify your answer?",
    definition: "To give reasons or evidence for something."
  },
  {
    word: "occur",
    image: "https://images.unsplash.com/photo-1606326608697-11bc8a57b9c6",
    synonyms: ["happen", "take place", "arise"],
    example: "Accidents often occur on this road.",
    definition: "To happen or take place."
  },
  {
    word: "obtain",
    image: "https://images.unsplash.com/photo-1529243856184-fd5465488984",
    synonyms: ["get", "acquire", "gain"],
    example: "He obtained a visa for his trip.",
    definition: "To get something through effort."
  },
  {
    word: "potential",
    image: "https://images.unsplash.com/photo-1614644147722-2a2b9ef59b25",
    synonyms: ["possibility", "capability", "promise"],
    example: "She has great potential as a leader.",
    definition: "The ability to develop or succeed in the future."
  },
  {
    word: "require",
    image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
    synonyms: ["need", "demand", "necessitate"],
    example: "This job requires strong communication skills.",
    definition: "To need something."
  },
  {
    word: "significant",
    image: "https://images.unsplash.com/photo-1609840117091-0e2ed65d5c2a",
    synonyms: ["important", "meaningful", "notable"],
    example: "There was a significant drop in sales.",
    definition: "Important or large enough to be noticed."
  },
  {
    word: "theory",
    image: "https://images.unsplash.com/photo-1610440447046-1ec1e0b69995",
    synonyms: ["idea", "principle", "hypothesis"],
    example: "Einstein’s theory changed physics forever.",
    definition: "An explanation based on evidence and reasoning."
  },
  {
    word: "vary",
    image: "https://images.unsplash.com/photo-1509021436665-8f07dbf5bf1d",
    synonyms: ["differ", "change", "fluctuate"],
    example: "Prices vary depending on the season.",
    definition: "To change or be different."
  },
  {
    word: "approach",
    image: "https://images.unsplash.com/photo-1580894894512-399f1d878362",
    synonyms: ["method", "strategy", "way"],
    example: "We need a new approach to solve this issue.",
    definition: "A method or way of doing something."
  },
  {
    word: "assume",
    image: "https://images.unsplash.com/photo-1580891012184-0f3b05caa399",
    synonyms: ["believe", "suppose", "presume"],
    example: "I assumed he had already left.",
    definition: "To believe something without proof."
  },
  {
    word: "conduct",
    image: "https://images.unsplash.com/photo-1509223197845-458d87318791",
    synonyms: ["carry out", "perform", "run"],
    example: "The scientists conducted an experiment.",
    definition: "To organize and carry out an activity."
  },
  {
    word: "establish",
    image: "https://images.unsplash.com/photo-1614642264761-69012d9d3ff6",
    synonyms: ["create", "build", "found"],
    example: "The school was established in 1990.",
    definition: "To set up or start something."
  },
  {
    word: "illustrate",
    image: "https://images.unsplash.com/photo-1529243856184-fd5465488984",
    synonyms: ["show", "demonstrate", "explain"],
    example: "This diagram illustrates the process.",
    definition: "To explain or make something clear using examples or pictures."
  }
];
